import Creator from '@/services/creator';

const state = {
    creator: { billingDetails: {} },
    expiresAt: null,
    subscription: false,
};

const getters = {
    getCreator: state => state.creator,
    getExpiresAt: state => state.expiresAt,
    getSubscription: state => state.subscription,
};

const actions = {
    async fetchCreator({ commit }) {
        const response = await Creator.getCreator();
        if (!response) {
            commit('setCreator', 'error');
        } else {
            commit('setCreator', response.data);
            commit('setExpiresAt', response.data.subscription);
        }
    },
};

const mutations = {
    setCreator: (state, creator) => (state.creator = creator),

    setExpiresAt(state, subscription) {
        if (subscription) {
            state.subscription = true;
            state.expiresAt = subscription.expiresAt;
        } else {
            state.subscription = false;
            state.expiresAt = '--//--';
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
